import check from './check';

/**
 * @deprecated use validators from src/utils/validators.ts or simple native checks such as `if (value)`
 */
export default (value: any, criterions: any) => !check(value, criterions);
